// Generate code from clean architecture template

import { OperationMethodEntity, OperationMethodTable } from '@/domains/operation-methods/entities';
import {
  QueryOperationMethodPayload,
  QueryOperationMethodsOutput,
} from '@/domains/operation-methods/ports/payloads';
import { OperationMethodRepository } from '@/domains/operation-methods/ports/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import { GET_ALL_OPERATION_METHODS, GET_OPERATION_METHOD_BY_ID } from '../../graphql';

export class OperationMethodHttpRepository implements OperationMethodRepository {
  async getListOperationMethod(
    payload?: QueryOperationMethodPayload,
  ): Promise<OperationMethodTable[]> {
    try {
      const response: QueryOperationMethodsOutput =
        await HttpClientAdapter.query<QueryOperationMethodsOutput>({
          query: GET_ALL_OPERATION_METHODS,
          dataKey: 'OperationMethod_getAll',
        });
      return response.data;
    } catch (error) {
      console.error('Error fetching operation methods:', error);
      throw error;
    }
  }

  async getDetailOperationMethod(id: string): Promise<OperationMethodEntity> {
    try {
      // Make sure the ID is a string to avoid type mismatches
      const idString = String(id);

      const response: OperationMethodEntity = await HttpClientAdapter.query<OperationMethodEntity>({
        query: GET_OPERATION_METHOD_BY_ID,
        dataKey: 'OperationMethod_getById',
        variables: { id: idString },
      });
      return response;
    } catch (error) {
      console.error(`Error fetching operation method with id ${id}:`, error);
      throw error;
    }
  }
}
